(() => {
  angular.module('finance').component('curlecPayoutSandboxComponent', {
    templateUrl: require('./curlecPayoutSandbox.component.html'),
    controller: CurlecPayoutSandboxComponent,
    controllerAs: 'vm',
    bindings: {
      pageState: '=',
    },
  });

  CurlecPayoutSandboxComponent.$inject = ['$uibModal', 'abp.services.finance.curlecPayout'];

  function CurlecPayoutSandboxComponent($uibModal, curlecPayoutSvc) {
    const vm = this;

    vm.loading = 0;

    vm.openPayoutStatusModal = openPayoutStatusModal;
    vm.openMerchantBalanceModal = openMerchantBalanceModal;
    vm.openAccountEnquiryModal = openAccountEnquiryModal;
    vm.openNewPayoutModal = openNewPayoutModal;

    init();

    function init() {}

    function openPayoutStatusModal() {
      $uibModal
        .open({
          templateUrl: require('./modals/curlecPayoutPayoutStatus.modal.html'),
          controller: 'curlecPayoutPayoutStatusModal as vm',
          backdrop: 'static',
          size: 'lg',
        })
    }

    function openMerchantBalanceModal() {
      $uibModal
        .open({
          templateUrl: require('./modals/curlecPayoutMerchantBalance.modal.html'),
          controller: 'curlecPayoutMerchantBalanceModal as vm',
          backdrop: 'static',
          size: 'lg',
        })
    }

    function openAccountEnquiryModal() {
      $uibModal
        .open({
          templateUrl: require('./modals/curlecPayoutAccountEnquiry.modal.html'),
          controller: 'curlecPayoutAccountEnquiryModal as vm',
          backdrop: 'static',
          size: 'lg',
        })
    }

    function openNewPayoutModal() {
      $uibModal
        .open({
          templateUrl: require('./modals/curlecPayoutNewPayout.modal.html'),
          controller: 'curlecPayoutNewPayoutModal as vm',
          backdrop: 'static',
          size: 'lg',
        })
    }
  }
})();
